import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  Injector,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DrawerComponentData, DrawerService } from '../../services/drawer.service';
import { ComponentPortal, CdkPortalOutlet } from '@angular/cdk/portal';
import { distinctUntilChanged } from 'rxjs/operators';
import { DRAWER_DATA } from 'src/app/shared/injector-tokens';
import { deepEqual } from 'src/app/shared/utils/deep-equal';

@Component({
  selector: 'drawer-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'flex h-full min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden bg-surface box-border [&>*]:flex [&>*]:h-full [&>*]:min-h-0 [&>*]:w-full [&>*]:flex-1 [&>*]:flex-col',
  },
  templateUrl: './drawer-content.component.html',
  imports: [CdkPortalOutlet],
})
export class DrawerContentComponent implements OnInit {
  private drawerService = inject(DrawerService);
  private _injector = inject(Injector);

  private readonly destroyRef = inject(DestroyRef);
  readonly portal = signal<ComponentPortal<unknown> | null>(null);

  ngOnInit() {
    this.drawerService.currentComponent$
      .pipe(
        distinctUntilChanged((a, b) => deepEqual(a, b)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(component => {
        if (component.reuseComponent && this.portal()?.component === component.type) return;

        this.portal.set(new ComponentPortal(component.type, null, this.createInjector(component.data)));
      });
  }

  createInjector(dataToPass: DrawerComponentData['data']): Injector {
    return Injector.create({
      parent: this._injector,
      providers: [{ provide: DRAWER_DATA, useValue: dataToPass }],
    });
  }
}
